import React from "react";
import "./styles/topContainer.css";
import QuickLink from '../../SharedComponents/QuickLink.js';
import "./styles/bottomContainer.css";
import "./styles/Carousel.css";
import MediaQuery from "react-responsive";
import CustomCarousel from "./components/CustomCarousel";
import OurResearch from './components/OurResearch';
import AboutUs from './components/aboutUs';
import OptimisedImage from "../../SharedComponents/OptimisedImage";
import { Link } from "react-router-dom";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

class LinkRow extends React.Component {
  render() {
    if (this.props.mobile===false) {
      return (<div className="linkRow" style={{gridTemplateColumns: "repeat("+this.props.children.length+", 1fr)"}}>
          {this.props.children}
        </div>)
    } else {
        return <>
          {this.props.children}
        </>
    }
  }
}

function aboutSupergen(mobile) {
  return(
    <div className="aboutSupergen">
      <h1>About the Supergen Bioenergy Hub</h1>
      <p>
        The <span className="bold">Super<span className="green">gen</span> Bioenergy Hub</span> works with academia, industry, government and societal stakeholders to develop sustainable bioenergy systems that support the UK’s transition to an affordable, resilient, low-carbon energy future.
      </p>
      <LinkRow mobile={mobile}>
        <QuickLink type="external" text="Supergen Website" link="https://www.supergen-bioenergy.net"/>
        <QuickLink type="external" text="Outputs" link="https://www.supergen-bioenergy.net/outputs/" />
        <QuickLink type="external" text="News" link="https://www.supergen-bioenergy.net/latest-news/" />
      </LinkRow>
    </div>
  );
}

function ourResearch() {
  return(
    <>
      <h1>Our Research</h1>
      <p>Our research is divided into four topic groups, each with their own aims and objectives.</p>
      <OurResearch />
    </>
  );
}

function appIntro() {
  return(
    <div className="introText" id="homepage-introtext">
      <div style={{ display: 'none' }}>
        <OptimisedImage image={require('./images/__assets__/background.jpg')} onLoad={e => {
          document.getElementById("homepage-introtext").style.backgroundImage = `url(${e.target.currentSrc})`;
        }}/>
      </div>
      <p>
        Welcome to the <span className="bold">Super<span className="green">gen</span> Bioenergy Hub</span>'s interactive research app. Explore our research, learn about bioenergy, and prepare for a renewable future.
      </p>
    </div>
  );
}

function newToBioenergy(mobile) {
  return(
    <div>
      <h1>New to Bioenergy?</h1>
          <p>
          <Link to="/wiki/Bioenergy">Bioenergy</Link> is the term used to 
          describe the generation of energy from organic materials 
          (<Link to="/wiki/Biomass">biomass</Link>). Biomass stores energy from 
          the sun; <Link to="/wiki/Combustion"> combustion</Link> or conversion 
          of biomass materials releases this energy.
          <br/><br/>
          Bioenergy may be generated from any organic material, the predominant 
          biomass fuels (<Link to="/wiki/Feedstock">feedstock</Link>s) widely 
          used include: wood, wastes, agricultural residues (e.g. straws), 
          agricultural wastes (e.g. manures) and crops grown specifically for 
          energy end-uses (energy crops).
          </p>
          <br/><br/>
          <div className="comicImage">
            <TransformWrapper defaultScale={1} style={{width: "100%", height: "100%"}}>
              {({ resetTransform }) => (
                <TransformComponent >
                  <OptimisedImage
                    alt="ComicImage"
                    image={require('./images/__assets__/ComicImage.png')}
                    style={{height: "auto", width: "100%"}}
                    onLoad={resetTransform}
                  />
                </TransformComponent>
              )}
            </TransformWrapper>

            <hr className="hr" style={{margin: 0, width: "100%", borderTop: "1px solid #ACACAC"}}/>
            <p>
              This image was illustrated by <Link to="/contributors/james-mckay">James McKay</Link>.
              It and its text were taken from the <a href="https://www.supergen-bioenergy.net/comic/">Supergen Bioenergy comic</a>.
            </p>
          </div>
          <br/><br/>
          <p>
          Check out the articles in the Wiki or read through the graphic novel 
          to gain a broader understanding of bioenergy:
          </p>
          <LinkRow mobile={mobile}>
            <QuickLink type="internal" text="Bioenergy Wiki" link="/wiki"/>
            <QuickLink type="external" text="Graphic Novel" link="https://www.supergen-bioenergy.net/comic/"/>
          </LinkRow>
    </div>
  );
}

class Home extends React.Component {
  render() {
    return (
      <div className="centered-feature">
        
        {/* first mediaquery catches larger devices */}
        <MediaQuery minWidth={600}>
          <div className="topContainer">
            {appIntro()}
            <CustomCarousel/>
          </div>
          <hr className="hr"/>
          {newToBioenergy(false)}
          <hr className="hr"/>
          {aboutSupergen(false)}
          <hr className="hr"/>
          {ourResearch()}
          <hr className="hr"/>
          <AboutUs/>
        </MediaQuery>
        {/* second mediaquery catches smaller devices */}
        <MediaQuery maxWidth={599}>
          {appIntro()}
          <CustomCarousel/>
          <hr className="hr"/>
          {newToBioenergy(true)}
          <hr className="hr"/>
          {aboutSupergen(true)}
          <hr className="hr"/>
          {ourResearch()}
          <hr className="hr"/>
          <AboutUs/>
        </MediaQuery>
      </div>
    );
  }
}

export default Home;
